import { useDataProvider } from '@ui-framework/index';
import { PageSection } from '@product-framework/index';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import schema from './edit.json';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../utils/getSPLevelStackableButtons';
import getConfig from '../../../configs/sp-location-config';
import SystemSettingClaims from '../../../components/SystemSettingsClaims';

const FORM_ID = 'ServiceProviderLocationClaimsSettingForm';
const PERMISSION_SP = 'SERVICEPROVIDERPROFILE';

function LocationClaimsSetting() {
  const navigate = useNavigate();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl } = useDataProvider(provider);
  const { serviceProviderId, locationId, refreshData } = useServiceProvider();

  const config = getConfig({
    apiBaseUrl: getApiUrl(),
    serviceProviderId,
    locationId,
  });

  const onChange = () => {
    refreshData({ refreshProfileWarnings: true });
  };

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_SYSTEM_SETTINGS"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        label={
          <FormattedMessage
            id="SYSTEM_SETTINGS_CLAIMS"
            defaultMessage="System Settings - Claims"
          />
        }>
        <SystemSettingClaims
          schema={schema}
          onChange={onChange}
          isLocationScope
          config={config}
          permission={PERMISSION_SP}
          formId={FORM_ID}
        />
      </PageSection>
    </ServiceProviderLayout>
  );
}

const LocationClaimsSettingObserver = observer(LocationClaimsSetting);
export default withServiceProvider(LocationClaimsSettingObserver);
